{
  "search-join-attendee-submit-btn": "Erledigt"
}